import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

import type { LADClaimFileForEmail } from '../../types';

export interface GetLADClaimFilesForEmailRequestParams {
  claimKey: number;
}

export const getLADClaimFilesForEmailAPI = (params: GetLADClaimFilesForEmailRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      ClaimKey: params.claimKey,
    },
    url: `${API.LOSS_AND_DAMAGE}/GetClaimFilesList`,
  });
};

export type LADClaimFilesForEmailResponse = LADClaimFileForEmail[];

export const fetchLADClaimFilesForEmail = async (
  params: GetLADClaimFilesForEmailRequestParams,
): Promise<LADClaimFilesForEmailResponse> => {
  const response: AxiosResponse<LADClaimFilesForEmailResponse> = await getLADClaimFilesForEmailAPI(params);
  return response.data ?? [];
};
